import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Ccsw5AuthWindowService } from '../../core/services/ccsw5-auth-window.service';

@Component({
  selector: 'app-ccsw-auth-callback',
  templateUrl: './ccsw-auth-callback.component.html',
  styleUrls: ['./ccsw-auth-callback.component.css'],
  standalone: false
})
export class CcswAuthCallbackComponent implements OnInit, OnDestroy {
  procesando = true;
  exitoso = false;
  mensaje = '';

  private readonly subs: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private externalWindow: Ccsw5AuthWindowService
  ) {}

  ngOnInit(): void {
    if (!this.externalWindow.estaAutenticacionEnCurso()) {
      this.procesando = false;
      this.mensaje = 'Acceso no autorizado.';
      if (window.opener && !window.opener.closed) {
        window.close();
      }
      return;
    }
    this.externalWindow.limpiarAutenticacionEnCurso();

    const sub = this.route.queryParams.subscribe((params) => {
      if (params['code'] && params['state'] === '1') {
        this.procesarCode(String(params['code']));
      } else {
        this.procesando = false;
        this.mensaje = 'No se recibió el código de autenticación.';
      }
    });
    this.subs.push(sub);
  }

  private procesarCode(code: string): void {
    try {
      const canal = new BroadcastChannel(Ccsw5AuthWindowService.channelName);
      canal.postMessage({ code, state: '1' });
      canal.close();
    } catch {
      /* ignore */
    }
    this.procesando = false;
    this.exitoso = true;
    this.mensaje = 'Autenticación completada. Puedes cerrar esta ventana.';
    setTimeout(() => {
      try {
        window.close();
      } catch {
        /* ignore */
      }
    }, 1200);
  }

  cerrar(): void {
    window.close();
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }
}
